import styled from 'styled-components';
import { Button } from '../utils/Button/Button';
import { Text14Light } from '../utils/Text/Text.styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 2.4rem;
  height: 100%;
`;

export const Header = styled.div`
  padding: 1.4rem 0 0 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: 1rem;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderText = styled(Text14Light)`
  opacity: 0.4;
`;

export const StyledButton = styled(Button)`
  width: 35rem;
  margin-top: 1rem;
  margin-inline: auto;

  @media only screen and (max-width: 500px) {
    margin-top: auto;
    width: 100%;
  }
`;

export const NumberOfPhotos = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;

export const Form = styled.form`
  width: 100%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 3rem;
  width: 100%;
`;

export const BackIconWrapper = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  left: 0;
`;
